var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartMixedUpCircleDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58984 8.04492L13.4805 1.70117L14.5 0.625L15.4629 1.70117L21.3535 8.04492L22.2598 9.06445L20.2773 10.9336L19.3711 9.91406L15.8594 6.11914V19.2031V20.5625H13.1406V19.2031V6.11914L9.57227 9.91406L8.66602 10.9336L6.68359 9.06445L7.58984 8.04492ZM14.5 26.9062C20.957 26.9062 26.2812 21.6387 26.2812 15.125V13.7656H29V15.125C29 23.168 22.4863 29.625 14.5 29.625C6.45703 29.625 0 23.168 0 15.125H2.71875C2.71875 21.6387 7.98633 26.9062 14.5 26.9062Z",
    fill: "#DA5252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMixedUpCircleDollar);
export default __webpack_public_path__ + "static/media/chart-mixed-up-circle-dollar.13b922c19a5044ccccd74baea50c676c.svg";
export { ForwardRef as ReactComponent };